/* RESPONSIBLE TEAM: team-ai-agent */
import Model, { attr } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
import { fragment } from 'ember-data-model-fragments/attributes';
import { states, type State } from 'embercom/models/data/matching-system/matching-constants';

const Validations = buildValidations({
  name: [
    validator('presence', {
      presence: true,
      messageKey: 'ai-agent.guidance.validation-errors.title.empty',
    }),
    validator('length', { max: 100, min: 1 }),
  ],
});

export default class EscalationRule extends Model.extend(Validations) {
  @attr('string') declare name: string;
  @attr('number') declare state: State;
  @attr('date') declare createdAt: Date;
  @fragment('predicates/predicate-group') declare predicateGroup: any;

  get enabled() {
    return this.state === states.live;
  }

  get hasPredicates() {
    return this.predicateGroup.hasPredicates;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ai-agent/escalation-rule': EscalationRule;
  }
}
